
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.107 8.202a5.037 5.037 0 10-.688.726l2.2 2.2a.5.5 0 10.707-.708L9.107 8.202zM7.976 2.268a4.036 4.036 0 11-5.708 5.708 4.036 4.036 0 015.708-5.708z"}})])
          )
        }
      }
    